
export default {
  props: {
    productFinderBanner: {
      type: Object,
      default: () => {},
    },
  },
}
